import { Card, Loader, BackButton } from '@fl/cmsch-fe-library';
import { toString } from 'lodash/fp';
import React, { FC, useCallback, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { AnimalBrowserAction } from 'app/animal-browser/model/action';
import { Content } from 'app/content';
import * as routerActions from 'app/router';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { replaceSpacesWithUnbreakableSpaces } from 'utils/replace-spaces-with-unbreakable-spaces';
import { CalfBrowserTable } from '../components/calf-browser';
import { animalBrowserAction, simpleAnimalBrowserSelector } from '../model';
interface DispatchProps {
  goTo(path: string): void;
  clearFarmName(): void;
}
const CalfBrowserBase: FC<DispatchProps> = props => {
  const farmInfo = useSelector(simpleAnimalBrowserSelector.farmInfo);
  const {
    t,
    tCommon
  } = useOurTranslation('animalBrowser');
  const farmNameOpt = farmInfo.prop('code').map(toString).noneIfEmpty();
  const {
    goTo,
    clearFarmName
  } = props;
  const cardTitle = useMemo(() => farmNameOpt.map(farmName => `${t('calvesInFarm')}: ${replaceSpacesWithUnbreakableSpaces(farmName)}`).caseOf(title => <ConnectedScreenHeader title={title} />, () => <Loader show />), [farmNameOpt, t]);
  const goBackToList = useCallback(() => {
    clearFarmName();
    goTo('/animal-browser/stables');
  }, [goTo, clearFarmName]);
  return <Content browserTabTitle={t('breedersBrowser')} data-sentry-element="Content" data-sentry-component="CalfBrowserBase" data-sentry-source-file="calf-browser.tsx">
            <Card title={cardTitle} titleSize="medium" extra={<BackButton text={tCommon('backToList')} onClick={goBackToList} />} noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="calf-browser.tsx">
                <CalfBrowserTable data-sentry-element="CalfBrowserTable" data-sentry-source-file="calf-browser.tsx" />
            </Card>
        </Content>;
};
const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  goTo: (path: string): void => void dispatch(routerActions.push(path)),
  clearFarmName: (): AnimalBrowserAction => dispatch(animalBrowserAction.clearFarmName())
});

/**
 * Renders the calf browser for the farm selected on the overview screen.
 *
 * @returns The farm-specific calf browser screen.
 */
export const CalfBrowser = connect(null, mapDispatchToProps)(CalfBrowserBase);